export class OptionSelectors {
    constructor(input_type,target_elements) {
        this.productSection = '[product-section]';
        this.OptionSelectors = '[option-selectors]';
        this.Option = '[option]';
        this.targetElements = target_elements;
        this.inputType = input_type;
        this.init();
    }

    init() {
        if (!Array.isArray(this.targetElements)) {
            console.error('targetElements must be an array');
            return;
        }
        document.body.addEventListener('change', this.handleChange.bind(this));
    }



    async handleChange(e) {
      // check that it isn't a range slider
      if (e.target.closest(this.OptionSelectors) && e.target.type !== 'range') {
        console.log("inside handle change check")
        // check if target has id is_gift and return
        if (e.target.id == 'is_gift') {
          return;
        }
        console.log("Handle change")
        await this.setForm(e.target);
        await this.updateProduct(e.target);
      }
    }

    variantImageChange(variant,gallery_slides) {
        if (!gallery_slides) {
            return;
        }
        // const if_card = this.product_form.getAttribute('data-card');
        // if (if_card == "true") {
        //     return;
        // }
        // const is_quickview = this.product_form.closest(".quick-view-modal") ? true : false;
        gallery_slides.forEach((slide, i) => {
            let index = i + 1;
            const slide_id = slide.dataset.id;
            const slide_index = slide.dataset.index;

            // Store order as a CSS variable instead of directly setting it
            let new_index = index++;
            slide.dataset.slideOrder = new_index;
            slide.style.setProperty('--slide-order', new_index);

            if (!slide_id) return;

            const slide_variant_ids = slide_id.split(',');
            if (slide_variant_ids.includes(variant.toString())) {

                if ( gallerySwiper ) gallerySwiper.slideTo(slide_index, 500);

                // Get the slide and bring it to the front
                const slide = gallery_slides[slide_index];
                if (slide) {
                    slide.style.setProperty('--slide-order', 0);
                    slide.dataset.slideOrder = 0;
                    // console.log("there is a slide: ", slide, 'slide id: ', slide_id);
                }
            }
        });

        // Get the new order from CSS and apply classes
        const orderedSlides = [...gallery_slides]
            .sort((a, b) => a.style.getPropertyValue('--slide-order') - b.style.getPropertyValue('--slide-order'));

        orderedSlides.forEach((slide, i) => {
            slide.classList.remove("big-image", "small-image", "first-slide", "second-slide");

            if ( i  === 0 ) {
                slide.classList.add("first-slide");
            } else if ( i === 1 ) {
                slide.classList.add("second-slide");
            }

            if (i % 3 === 0) {
                slide.classList.add("big-image"); // Every 3rd image (0-based index) is big
            } else {
                slide.classList.add("small-image"); // The rest are small
            }
        });

    }


    async setForm(target) {
        const form = target.closest(this.productSection).querySelector('product-form form');
        this.form = form;
        if (!form) return;
        await this.setSectionId(form);
        await this.setProductId(form);
        await this.setUpdateHTML(form);
        await this.getOldProductURL(form);
        await this.getInputType(target);
        await this.getVariantId(target);
        await this.setNewProductURL(target);
        await this.findSectionsToRender(target);
    }

    async getInputType(target) {
        return new Promise((resolve) => {
            if (target.tagName == 'SELECT') {
                this.inputType = 'select';
                resolve();
            } else {
                this.inputType = 'radio';
                resolve();
            }
        });
    }

    async setNewProductURL(target) {
        return new Promise((resolve) => {
            if (this.inputType == 'select') {
                const selectedOption = target.options[target.selectedIndex];
                this.newProductUrl = selectedOption.getAttribute('data-product-url');
                resolve();
            } else {
                const newProductUrl = target.getAttribute('data-product-url');
                this.newProductUrl = newProductUrl;
                resolve();
            }
        });
    }

    async setSectionId(form) {
        return new Promise((resolve) => {
            const sectionId = form.getAttribute('data-section-id');
            this.sectionId = sectionId;
            resolve();
        });
    }

    async setProductId(form) {
        return new Promise((resolve) => {
            const productId = form.getAttribute('data-product-id');
            this.productId = productId;
            resolve();
        });
    }

    async getOldProductURL(form) {
        return new Promise((resolve) => {
            const oldProductURL = form.getAttribute('data-product-url');
            this.oldProductURL = oldProductURL;
            resolve();
        });
    }

    async getVariantId(target) {
        return new Promise((resolve) => {
            if (this.inputType == 'select') {
                const selectedOption = target.options[target.selectedIndex];
                this.variantId = selectedOption.getAttribute('data-variant-id');
                resolve();
            } else {
                const variantId = target.getAttribute('data-variant-id');
                this.variantId = variantId;
                resolve();
            }
        });
    }

    async setUpdateHTML(form) {
        this.HTMLSelector = this.productSection;
        const updateHTML = form.closest(this.HTMLSelector);
        this.updateHTML = updateHTML;
    }

    updateURL(newURL, variantId) {
        const url = new URL(window.location);
        url.pathname = newURL; // Update the base URL

        if (variantId) {
            url.searchParams.set('variant', variantId); // Set or update the variant parameter
        } else {
            url.searchParams.delete('variant'); // Remove the variant parameter if no ID is provided
        }

        window.history.replaceState({}, '', url.toString());
    }

    // updateSwipers(newHTML) {
    //     // Check if the element exists
    //     const scriptElement = newHTML.querySelector("[gallery-swipers]");

    //     if (scriptElement) {
    //     // Get the text content of the <script> element
    //         let gallery_swipers = scriptElement.textContent;

    //         // Clean up the content if necessary (be very cautious here)
    //         // Check first if we have the tags in the content.
    //         if(gallery_swipers.includes("</script>") && gallery_swipers.includes("<script gallery-swipers>")){
    //             gallery_swipers = gallery_swipers.replace("</script>", "").replace("<script gallery-swipers>", "");
    //         }
    //         try{
    //             new Function(gallery_swipers)();
    //         } catch(error){
    //             console.error("Error executing script:",error);
    //         }
    //         // Get closest this.productSection from this.form
    //         // const productSection = document.querySelector(`#ProductSection-${this.sectionId}-${this.productId}`);
    //         // if (!productSection) {
    //         //     return;
    //         // }
    //         const gallery_slides = productSection.querySelectorAll('[main-gallery] .main-swiper-slide');
    //         // console.log("🚀 ~ OptionSelectors ~ .then ~ productSection:", productSection)

    //         if (gallery_slides.length > 0) {
    //             this.variantImageChange(this.variantId, gallery_slides);
    //         }
    //     } else {
    //         console.warn("No element found with the 'gallery-swipers' attribute.");
    //     }
    // }

    async findSectionsToRender(target) {
      // Find other sections to render
      const nearestSection = target.closest('.shopify-section');

      // find sibling elemeents to nearest section which contain an element with the attribute [section-render]
      const sectionsToRender = [];
      const siblingSections = nearestSection.parentNode.querySelectorAll('.shopify-section');
      siblingSections.forEach((section) => {
        const sectionRenderEl = section.querySelector('[section-render]');
        if (sectionRenderEl && section !== nearestSection) {
          const section_id = section.id;
          // remove 'shopify-section-' from section_id
          const sectionId = section_id.replace('shopify-section-', '');
          sectionsToRender.push(sectionId);
        }
      });

      this.sectionsToRender = sectionsToRender;
    }

    findUpsells(html) {
      const upsells = html.querySelectorAll('[product-upsell]');

      if (!upsells) return;

        upsells.forEach((upsell) => {
          const qty_select = upsell.querySelector('[quantity-select] input');
          qty_select.value = 0;
          upsell.querySelector('[quantity]').innerHTML = 0;
          upsell.removeAttribute('upsell-selected');
        }
      )
    }

    async updateProduct(target) {
      // set a flag so the fewtch doesn't run if method is called again before the first one is finished
      if (this.fetching) {
          return; // don't run the fetch if it's already running
      }
      this.fetching = true;

        // get other sections on page to section render
        this.targetElements.forEach((element) => {
          const oldElement = this.updateHTML.querySelector(element);
          if (!oldElement) {
            console.log("Can't find old element: ",element);
            return;
          }
          oldElement.classList.add('deselect');
        });

        let params = `section_id=${this.sectionId}&`;

        let section_params = "";

        if (this.sectionsToRender.length > 0) {
          // add this.sectionId to this.findSectionsToRender(target)
          // convert array to string with comma separated values
          this.sections = this.sectionsToRender.join(',');
          section_params = `sections=${this.sections}&`;
        }


        if (this.variantId) {
            // If the option value has a variant selection, call the section rendering api for that variant
            params += `variant=${this.variantId}`;
            if (section_params) {
              section_params += `variant=${this.variantId}`;
            }
        } else {
            console.log("no variant id");
            // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
            // const selectedOptionValues = Array.from(this.updateHTML.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
            // params += `option_values=${selectedOptionValues}`;
        }

        this.findUpsells(this.updateHTML);

        // Call the section rendering api

        fetch(`${this.newProductUrl}?${params}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.fetching = false; // reset the flag
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newHTML = html.querySelector(this.HTMLSelector);

          if (this.newProductUrl && this.oldProductURL !== this.newProductUrl) {
            const parent = this.updateHTML.parentNode;
            parent.insertAdjacentHTML('beforeend', newHTML.outerHTML);
            this.updateHTML.remove();
            document.querySelector(`#${target.id}`).focus();
            // update page url
            this.updateURL(this.newProductUrl, this.variantId);
            this.updateSwipers(newHTML);
            return;
          }

          this.targetElements.forEach((element) => {
            const newElement = newHTML.querySelector(element);
            const oldElement = this.updateHTML.querySelector(element);
            if (!oldElement) {
              console.log("Can't find old element: ", element);
              return;
            }
            if (!newElement) {
              console.log("Can't find new element: ", element);
              return;
            }
            oldElement.classList.remove('deselect');
            oldElement.innerHTML = newElement.innerHTML;
          });



          if (this.inputType == 'select') {
            // If the target is a select element, select the option based on the variant ID
            // const selectElement = document.querySelector(`#${target.id}`);
            // selectElement.value = this.variantId;
          } else {
            document.querySelector(`#${target.id}`).focus();
          }

          this.updateURL(this.oldProductURL, this.variantId);
          const gallery_slides = document.querySelectorAll('[main-gallery] .main-swiper-slide');
          if (gallery_slides.length > 0) {
            this.variantImageChange(this.variantId, gallery_slides);
          } else {
            console.log("No gallery slides found");
          }
        });

        if (this.sectionsToRender.length > 0) {
          fetch(`${this.newProductUrl}?${section_params}`)
          .then((response) => response.json())
          .then((sections) => {

            // Loop through each section and update the corresponding element in the DOM
            for (const sectionId in sections) {
              const sectionHTML = sections[sectionId];
              // convert to html element
              // const parser = new DOMParser();
              // const doc = parser.parseFromString(sectionHTML, 'text/html');
              // const inner = doc.innerHTML;

              const sectionElement = document.querySelector(`#shopify-section-${sectionId}`);
              if (sectionElement) {
                // Insert new section HTML *after* the old section
                sectionElement.insertAdjacentHTML('afterend', sectionHTML);
                // Remove the old section element
                sectionElement.remove();
              } else {
                console.warn(`Section with ID ${sectionId} not found in the DOM.`);
              }
            }
            // ...
          })
          .catch((error) => {
            console.error("Error fetching sections:", error);
          });

        }

    }
}